import { useIsAskMeAnythingEnabled } from '@ms/yammer-hooks/dist/askMeAnything';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { UseUIFeatureCheck } from '../types';

export { useIsAskMeAnythingEnabled, useIsAskMeAnythingEnabled as useAreAMAEventsEnabled };

export const useIsTownhallEventEnabled: UseUIFeatureCheck = () => {
  const townhallEventExperiment = useExperimentTreatmentWithoutReporting('TeamsTownhallEventInVivaEngage');

  return townhallEventExperiment === true;
};
